<template>
  <div :class="['notifications-component', showBell && 'notifications-component--visible', pulse && 'notifications-component--pulse']">
    <div class="notifications-component__icon" @click="toggle">
      <font-awesome-icon icon="bell" />
    </div>
    <div :class="['notifications-component__content', open && 'notifications-component__content--visible']" v-on-clickaway="close">
      <slot>
      </slot>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import _ from 'lodash';

export default {
  name: 'notification',
  mixins: [ clickaway ],
  data: () => ({
    closable: false,
    open: false,
    pulse: true,
  }),
  computed: {
    notifications() {
      if (Array.isArray(this.$slots.default)) {
        return this.$slots.default.filter(q => Array.isArray(q.children));
      }
      return [];
    },
    showBell() {
      return this.notifications.length > 0;
    }
  },
  methods: {
    close() {
      if (this.closable) {
        this.open = false;
      }
    },
    show() {
      this.open = false;
      this.toggle();
    },
    toggle() {
      this.open = !this.open;
      if (this.open) {
        this.closable = false;
        this.pulse = false;
        _.debounce(() => {
          this.closable = true;
        }, 250)();
      }
    }
  }
}
</script>

<style lang="scss">
.notifications-component {
  color: white;
  position: absolute;
  right: 32px;
  top: 82px;
  visibility: hidden;

  &.notifications-component--visible {
    visibility: visible;
  }
  &.notifications-component--pulse {
    animation: pulse 3s infinite;
  }

  .notifications-component__icon {
    svg {
      z-index: 1;
      position: relative;
      width: 28px;
      height: 28px;
      top: -19px;
      right: 15px;
      pointer-events: none;
    }
    &::before {
      content: "";
      border-radius: 50%;
      background-color: gray;
      width: 48px;
      height: 48px;
      left: 23px;
      top: -7px;
      position: relative;
      display: inline-block;
      z-index: 0;
      cursor: pointer;
    }
  }
  .notifications-component__content {
    visibility: hidden;
    position: absolute;
    background-color: $panel;
    border: 3px solid $secondary;
    color: $black;
    width: 80vw;
    max-width: 280px;
    right: 0;
    display: flex;
    flex-flow: column nowrap;
    gap: 5px;
    text-align: left;
    padding: 5px;

    &.notifications-component__content--visible {
      visibility: visible;
      -webkit-animation: blind-in .25s 1;
      animation: blind-in .25s 1;
    }
  }
}

@-webkit-keyframes blind-in {
  0% { transform: scaleY(0); }
  100% { transform: scaleY(1);}
}
@keyframes blind-in {
  0% { transform: scaleY(0); }
  100% { transform: scaleY(1);}
}

@keyframes pulse {
  0% { color: white; }
  70% { color: white;}
  85% { color: $orange; }
}
</style>
